import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Es un libro físico?',
  a: 'No, es un producto digital descargable (PDF) para que puedas empezar tu sanación hoy mismo de forma inmediata y discreta.'
}, {
  q: '¿Sirve si todavía vivo con él?',
  a: 'Sí, incluye las herramientas de "Piedra Gris" diseñadas específicamente para proteger tu energía mientras preparas tu salida.'
}, {
  q: '¿Qué pasa si tenemos hijos?',
  a: 'El sistema incluye una sección estratégica sobre comunicación logística y protección emocional para madres.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Sí, utilizamos cifrado de alta seguridad para proteger tu transacción.'
}, {
  q: '¿Funcionará si mi caso es muy extremo?',
  a: 'El método R.E.S.E.T. está diseñado precisamente para los casos donde el daño al sistema nervioso y el vínculo de trauma son profundos.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-800" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <FadeIn data-id="element-30">
          <h2 className="text-3xl md:text-4xl text-center mb-12" data-id="element-31">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-33">
              <div className="border border-dark-700 rounded-lg overflow-hidden bg-dark-900/50" data-id="element-34">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-dark-800/50 transition-colors" data-id="element-35">
                  <span className="font-serif text-lg text-offwhite" data-id="element-36">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-37" />
                </button>
                <AnimatePresence data-id="element-38">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-39">
                      <div className="p-6 pt-0 text-offwhite/70 font-light leading-relaxed border-t border-dark-700/50 mt-2" data-id="element-40">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}